"use strict";

var MggpPlayer = require('mggp-player');
var MggpVendor = MggpPlayer.Vendor;
var AddonError = MggpPlayer.AddonError;
//var MggpPluginBuffering = require('mggp-plugin-buffering');
var Hls = require('hls.js');
window.Hls = Hls;

function MggpVendorHls(pPlayer, pConfig) {
  MggpVendor.apply(this, arguments);

  var self = this;
  var hlsConfig = {
    debug: false,
    manifestLoadingMaxRetry: 0,
    levelLoadingMaxRetry: 0,
    backBufferLength: 10,
    liveDurationInfinity: false,
    /*maxBufferHole: 2,
    maxBufferLength: 300*/
  };

  try {
    hlsConfig.liveDurationInfinity = self.player.config.device.os.name
      .toLowerCase()
      .includes("ios");
  } catch (error) {
    console.error(error);
  }

  var pluginBuffering;

  /*if (self.player.get('player:usePluginBuffering')) {
    pluginBuffering = new MggpPluginBuffering(pPlayer, pConfig);
  }*/

  for (var key in pConfig) {
    hlsConfig[key] = pConfig[key];
  }
  hlsConfig.debug = Boolean(pConfig.hlsDebug);

  var _hls;// = new Hls(hlsConfig);
  var _src = null;
  var _videoInfo = null;
  var _video = null;
  var _startPosition = 0;
  var _started = false;
  var _paused = false;
  // eslint-disable-next-line no-unused-vars
  var _state = 0;
  var _beforeCompleteFired = false;
  var _isLive = false;
  // var _lastTimestamp = void 0;
  var _bufferingIntervalId = void 0;
  var _isBuffering = false;
  var _stateBeforeSeeking = null;
  var _nonFatalErrorsCount = 0;

  var _recoverDecodingErrorDate = 0;
  var _recoverSwapAudioCodecDate = 0;
  var _isSafari;

  this.dispose = function () {
    toggleEvents(false);
    toggleHlsEvents(false);

    if (_hls) {
      _hls.destroy();
    }

    if (_bufferingIntervalId) {
      clearInterval(_bufferingIntervalId);
      _bufferingIntervalId = void 0;
    }

    _hls = null;
    _src = null;
    _videoInfo = null;
    _nonFatalErrorsCount = 0;
    if (!self.player.config['singleVideoInstance']) {//MHP-1877
      _video = null;
      self.player = null;
      self.namespase = null;
      self.config = null;
    }
    // _lastTimestamp = void 0;
    _isBuffering = false;

    if (pluginBuffering) {
      pluginBuffering.dispose();
    }
  };

  this.load = function (pSrc, pVideoInfo, pOptions) {
    var browserName;
    try {
      browserName = self.player.config.device.browser.name.toLowerCase();
    } catch (error) {
      console.error(error);
    }
    // browsers
    _isSafari = browserName === 'safari';

    if (_bufferingIntervalId) {
      clearInterval(_bufferingIntervalId);
      _bufferingIntervalId = void 0;
    }

    if (pOptions) {
      if (!self.checkOptions(pOptions)) return;
    } else {
      pOptions = {};
    }
    setState(5);

    _videoInfo = pVideoInfo ? pVideoInfo : _videoInfo || null;
    _src = pSrc || pVideoInfo.src;

    if (!_videoInfo && (!_src || _src === '')) {
      self.emit('player:mediaError', { message: 'Src not found' });
      return;
    }
    if (!_video) {
      createPlayer();
    }
    toggleEvents(true);

    _video.autoplay = true;

    setVideoVolume(self.get('volume') / 100);

    if (self.get('muted')) {
      _video.muted = true;
    }

    if (_hls) {
      _hls.destroy();
    }
    _hls = new Hls(hlsConfig);
    _started = false;
    //resetHls()
    toggleHlsEvents(true);
    _hls.attachMedia(_video);
    _hls.loadSource(_src);

    if ('startSeconds' in pOptions) {
      _startPosition = parseFloat(pOptions['startSeconds']);
    }

  };

  this.play = function () {
    if (_video.currentSrc) _video.play();
  };

  this.pause = function () {
    if (_video && !_paused) {
      _paused = true;
      _video.pause();
    }
  };

  this.stop = function () {
    if (_video) {
      if (self.player.config['singleVideoInstance'] === true) {
        _video.style.display = 'none';
        _video.pause();
        _video.removeAttribute('src'); // empty source
        _video.load();
      } else {
        self.container.removeChild(_video);
      }

    }
    self.dispose();
  };

  this.togglePlayPause = function () {
    if (_video) {
      self.get('state') === 1 ? this.pause() : this.play();
    }
  };

  this.seekTo = function (seconds) {
    if (!_video) {
      return;
    }
    if (typeof seconds !== 'number' || Number.isNaN(seconds)) {
      self.log('seekTo: argument "seconds" has invalid value:', seconds);
      return;
    }
    if (!_stateBeforeSeeking) {
      _stateBeforeSeeking = _video.paused ? 2 : 1;
    }
    setState(5);
    var timeToSeek = Math.min(Math.max(0, seconds), Math.min(self.get('duration') - 10, seconds));
    _video.currentTime = timeToSeek;
    self.set('position', timeToSeek);
  };

  this.setVolume = function (pVolume) {
    if (pVolume > 100) {
      pVolume = 100;
    } else if (pVolume < 0) {
      pVolume = 0;
    }
    if (_video) {
      setVideoVolume(pVolume / 100);
    }
    self.set('volume', pVolume);
  };

  this.mute = function () {
    if (self.get('muted')) return;
    self.set('muted', true);
    _video.muted = true;
  };

  this.unMute = function () {
    if (!self.get('muted')) return;
    self.set('muted', false);
    _video.muted = false;
  };

  this.getPlayableElement = function () {
    return _video;
  };

  this.setQuality = function (newBitrate) {
    var i, l;
    if (!_started) {
      var videoInfo = self.player.get('videoInfo');
      if (videoInfo && videoInfo.bitrates && videoInfo.bitrates.length > 0) {
        for (i = 0, l = videoInfo.bitrates.length; i < l; ++i) {
          if (videoInfo.bitrates[i].bitrate === newBitrate && !videoInfo.bitrates[i].subscription_restricted) {
            self.player.set('quality', newBitrate);
            break;
          }
        }
      }
      self.load(self.player.get('src'), videoInfo, self.player.get('vendorOptions'));
    } else {
      // setState(5);
      if (self.player.get('quality') === newBitrate) return;
      if (newBitrate === -1) {
        _hls.nextLevel = newBitrate;
        self.player.set('quality', newBitrate);
      } else {
        var indexByName = getQualityIndexByName(newBitrate);
        if (indexByName != null && indexByName >= 0) {
          _hls.currentLevel = indexByName;
          self.player.set('quality', newBitrate);
          return;
        }

        var bitrates = self.player.get('qualityList');
        if (bitrates && bitrates.length > 1) {
          for (i = 0, l = bitrates.length; i < l; ++i) {
            if (newBitrate === bitrates[i].bitrate) {
              _hls.currentLevel = bitrates[i].index;
              self.player.set('quality', newBitrate);
              break;
            }
          }
        }
      }
    }
  };

  var getQualityIndexByName = function(pName) {
    if (!_hls || !_hls.levels) {
      return null;
    }

    for (var i = 0; i < _hls.levels.length; i++) {
      if (isHlsLevelMatched(_hls.levels[i], pName)) {
        return i;
      }
    }

    return null;
  };

  var isHlsLevelMatched = function(hlsLevel, desiredBitrate) {
    return Boolean(hlsLevel.name && parseInt(hlsLevel.name) === desiredBitrate);
  };

  var getBitrateIndex = function(bitrate) {
    var result = -1;
    var i, l;
    var bitrates = self.player.get('qualityList');
    if (bitrates && bitrates.length > 0) {
      for (i = 0, l = bitrates.length; i < l; ++i) {
        if (bitrates[i].bitrate === bitrate) {
          result = bitrates[i].index;
          break;
        }
      }
    } else if (!bitrates || bitrates.length === 0) {
      var videoInfo = self.player.get('videoInfo');
      if (videoInfo) {
        bitrates = videoInfo.bitrates;

        var zeroIsAbsent = true,
          oneIsPresents = false;
        for (i = 0, l = bitrates.length; i < l; ++i) {
          if (bitrates[i].index === 0) {
            zeroIsAbsent = false;
          } else if (bitrates[i].index === 1) {
            oneIsPresents = true;
          }
          if (bitrates[i].bitrate === bitrate) {
            result = bitrates[i].index;
          }
        }
        if (zeroIsAbsent && oneIsPresents && result !== -1) {
          --result;
        }
      }
    }

    return result;
  };

  var createPlayer = function () {
    if (self.player.config['singleVideoInstance'] === true) {
      _video = self.player.get(self.namespace + 'video');
    }

    if (!_video) {
      _video = document.createElement('video');
      self.container.appendChild(_video);
    }

    _video.className = self.namespace + 'video';
    _video.style.width = "100%";
    _video.style.height = "100%";
    _video.style.display = 'inline-block';

    if (pluginBuffering) {
      pluginBuffering.setVideo(_video);
    }
  };

  var setState = function (pNewState) {
    _state = pNewState;
    self.set('state', pNewState);
    self.emit('stateChange', pNewState);
  };

  var toggleEvents = function (pOn) {

    if (pOn) {
      if (_video) {
        _video.addEventListener("loadstart", onVideoLoadStart);
        _video.addEventListener("canplay", onVideoCanPlay);
        _video.addEventListener("pause", onVideoPause);
        _video.addEventListener("playing", onVideoPlaying);
        _video.addEventListener("seeked", onVideoSeeked);
        _video.addEventListener("seeking", onVideoSeeking);
        _video.addEventListener("volumechange", onVideoVolumeChange);
        _video.addEventListener("durationchange", onVideoDurationChange);
        _video.addEventListener("ended", onVideoEnded);
        _video.addEventListener("error", onVideoError);
        _video.addEventListener("waiting", onVideoWaiting);
      }

      if (self.player && self.player.on) {
        self.player.on("player:timeUpdate", onTimeUpdate);
      }

      if (_bufferingIntervalId) {
        clearInterval(_bufferingIntervalId);
      }

    } else {
      if (_video) {
        _video.removeEventListener("loadstart", onVideoLoadStart);
        _video.removeEventListener("canplay", onVideoCanPlay);
        _video.removeEventListener("pause", onVideoPause);
        _video.removeEventListener("playing", onVideoPlaying);
        _video.removeEventListener("seeked", onVideoSeeked);
        _video.removeEventListener("seeking", onVideoSeeking);
        _video.removeEventListener("volumechange", onVideoVolumeChange);
        _video.removeEventListener("durationchange", onVideoDurationChange);
        _video.removeEventListener("ended", onVideoEnded);
        _video.removeEventListener("error", onVideoError);
        _video.removeEventListener("waiting", onVideoWaiting);
      }


      if (self.player && self.player.off) {
        self.player.off("player:timeUpdate", onTimeUpdate);
      }

      if (_bufferingIntervalId) {
        clearInterval(_bufferingIntervalId);
        _bufferingIntervalId = void 0;
      }
    }
  };

  function toggleHlsEvents(on) {
    if (on) {
      if (_hls) {
        _hls.on(Hls.Events.MANIFEST_PARSED, onManifestParsed);
        _hls.on(Hls.Events.FRAG_LOADED, onFragLoaded);
        _hls.on(Hls.Events.ERROR, onHlsError);
        _hls.on(Hls.Events.LEVEL_SWITCHED, onLevelSwitch);
        _hls.on(Hls.Events.LEVEL_LOADED, onLevelLoaded);
        _hls.on(Hls.Events.AUDIO_TRACKS_UPDATED, onAudioTrackUpdated);
        _hls.on(Hls.Events.AUDIO_TRACK_SWITCHED, onAudioTrackSwitched);
      }
    } else {
      if (_hls) {
        _hls.off(Hls.Events.MANIFEST_PARSED, onManifestParsed);
        _hls.off(Hls.Events.FRAG_LOADED, onFragLoaded);
        _hls.off(Hls.Events.ERROR, onHlsError);
        _hls.off(Hls.Events.LEVEL_SWITCHED, onLevelSwitch);
        _hls.off(Hls.Events.LEVEL_LOADED, onLevelLoaded);
        _hls.off(Hls.Events.AUDIO_TRACKS_UPDATED, onAudioTrackUpdated);
        _hls.off(Hls.Events.AUDIO_TRACK_SWITCHED, onAudioTrackSwitched);
      }
    }
  }

  function setVideoVolume(volume) {
    _video.removeEventListener("volumechange", onVideoVolumeChange);
    _video.volume = volume;
    setTimeout(function() {
      if (_video) {
        _video.addEventListener("volumechange", onVideoVolumeChange);
      }
    }, 0);
  }

  var onHlsError = function (evt, data) {
    var errorType, errorCode, errorMessage, isFatal;

    switch (data.details) {
      case Hls.ErrorDetails.MANIFEST_LOAD_ERROR:
        try {
          self.log("cannot Load <a href=\"" + data.url + "\">" + data.url + "</a><br>HTTP response code:" + data.response.status + "<br>" + data.response.statusText);
          if (data.response.status === 0) {
            /*
            TODO: due to such status reporting present only in hls.js/demo,
              we could complete remove it, or, if necessary keep attempt to reporting, but:
                - switch to no-jQuery, like `window.HlsStatus`
                - when update hls.js to latest version replace with #statusOut
            */
            $("#HlsStatus").append("this might be a CORS issue, consider installing <a href=\"https://chrome.google.com/webstore/detail/allow-control-allow-origi/nlfbmbojpeacfghkpbjhddihlkkiljbi\">Allow-Control-Allow-Origin</a> Chrome Extension");
          }
        } catch (err) {
          self.log("cannot Load <a href=\"" + data.url + "\">" + data.url + "</a><br>Reason:Load " + (data.event && data.event.type));
        }
        errorType = AddonError.errorTypes.NETWORK_ERROR;
        errorCode = AddonError.errorCodes[errorType].PLAYLIST_LOADING_ERROR;
        errorMessage = AddonError.errorMessages[errorCode] + data.url;
        isFatal = true;
        break;
      case Hls.ErrorDetails.MANIFEST_LOAD_TIMEOUT:
        self.log("timeout while loading manifest");
        errorType = AddonError.errorTypes.NETWORK_ERROR;
        errorCode = AddonError.errorCodes[errorType].PLAYLIST_LOADING_ERROR;
        errorMessage = AddonError.errorMessages[errorCode] + data.url + " TIMEOUT";
        isFatal = true;
        break;
      case Hls.ErrorDetails.MANIFEST_PARSING_ERROR:
        self.log("error while parsing manifest:" + data.reason);
        errorType = AddonError.errorTypes.PLAYBACK_ERROR;
        errorCode = AddonError.errorCodes[errorType].PARSING_ERROR;
        errorMessage = AddonError.errorMessages[errorCode] + data.url;
        isFatal = true;
        break;
      case Hls.ErrorDetails.LEVEL_LOAD_ERROR:
        self.log("error while loading level playlist");
        errorType = AddonError.errorTypes.NETWORK_ERROR;
        errorCode = AddonError.errorCodes[errorType].CHUNKLIST_LOADING_ERROR;
        errorMessage = AddonError.errorMessages[errorCode] + data.url;
        isFatal = true;
        break;
      case Hls.ErrorDetails.LEVEL_LOAD_TIMEOUT:
        self.log("timeout while loading level playlist");
        self.log("error while loading level playlist");
        errorType = AddonError.errorTypes.NETWORK_ERROR;
        errorCode = AddonError.errorCodes[errorType].CHUNKLIST_LOADING_ERROR;
        errorMessage = AddonError.errorMessages[errorCode] + data.url + ' TIMEOUT';
        isFatal = true;
        break;
      case Hls.ErrorDetails.LEVEL_SWITCH_ERROR:
        self.log("error while trying to switch to level " + data.level);
        handleMediaError();
        errorType = AddonError.errorTypes.PLAYBACK_ERROR;
        errorCode = AddonError.errorCodes[errorType].LEVEL_SWITCH_ERROR;
        errorMessage = AddonError.errorMessages[errorCode] + data.url;
        isFatal = false;
        break;
      case Hls.ErrorDetails.FRAG_LOAD_ERROR:
        self.log("error while loading fragment " + data.frag.url);
        errorType = AddonError.errorTypes.NETWORK_ERROR;
        errorCode = AddonError.errorCodes[errorType].CHUNK_LOADING_ERROR;
        errorMessage = AddonError.errorMessages[errorCode] + (data.frag ? data.frag.url : 'url unknown');
        // Спустя 6 попыток с нарастающим интервалом ошибка становится фатальной
        // config.fragLoadingMaxRetry (default:6)
        isFatal = data.fatal;
        break;
      case Hls.ErrorDetails.FRAG_LOAD_TIMEOUT:
        self.log("timeout while loading fragment " + data.frag.url);
        errorType = AddonError.errorTypes.NETWORK_ERROR;
        errorCode = AddonError.errorCodes[errorType].CHUNK_LOADING_ERROR;
        errorMessage = AddonError.errorMessages[errorCode] + (data.frag ? data.frag.url : 'url unknown') + ' TIMEOUT';
        isFatal = false;
        break;
      case Hls.ErrorDetails.FRAG_LOOP_LOADING_ERROR:
        self.log("Frag Loop Loading Error");
        errorType = AddonError.errorTypes.NETWORK_ERROR;
        errorCode = AddonError.errorCodes[errorType].CHUNK_LOADING_ERROR;
        errorMessage = AddonError.errorMessages[errorCode] + (data.frag ? data.frag.url : 'url unknown');
        isFatal = false;

        if (self.get("position") < 1 && self.get("state") === 5) {
          _hls.recoverMediaError();
        }

        break;
      case Hls.ErrorDetails.FRAG_DECRYPT_ERROR:
        self.log("Decrypting Error:" + data.reason);
        errorType = AddonError.errorTypes.PLAYBACK_ERROR;
        errorCode = AddonError.errorCodes[errorType].DECODING_ERROR;
        errorMessage = AddonError.errorMessages[errorCode] + data.url;
        isFatal = false;
        break;
      case Hls.ErrorDetails.FRAG_PARSING_ERROR:
        errorType = AddonError.errorTypes.PLAYBACK_ERROR;
        errorCode = AddonError.errorCodes[errorType].DECODING_ERROR;
        errorMessage = AddonError.errorMessages[errorCode] + data.url;
        isFatal = false;
        break;
      case Hls.ErrorDetails.KEY_LOAD_ERROR:
        self.log("error while loading key " + data.frag.decryptdata.uri);
        errorType = AddonError.errorTypes.NETWORK_ERROR;
        errorCode = AddonError.errorCodes[errorType].KEY_LOADING_ERROR;
        errorMessage = AddonError.errorMessages[errorCode] + data.url;
        isFatal = false;
        break;
      case Hls.ErrorDetails.KEY_LOAD_TIMEOUT:
        self.log("timeout while loading key " + data.frag.decryptdata.uri);
        errorType = AddonError.errorTypes.NETWORK_ERROR;
        errorCode = AddonError.errorCodes[errorType].KEY_LOADING_ERROR;
        errorMessage = AddonError.errorMessages[errorCode] + data.url + ' TIMEOUT';
        isFatal = false;
        break;
      case Hls.ErrorDetails.BUFFER_APPEND_ERROR:
        self.log("Buffer Append Error");
        errorType = AddonError.errorTypes.INTERNAL_ERROR;
        errorCode = AddonError.errorCodes[errorType].BUFFER_APPEND_ERROR;
        errorMessage = AddonError.errorMessages[errorCode];
        isFatal = false;
        break;
      case Hls.ErrorDetails.BUFFER_APPENDING_ERROR:
        self.log("Buffer Appending Error");
        errorType = AddonError.errorTypes.INTERNAL_ERROR;
        errorCode = AddonError.errorCodes[errorType].BUFFER_APPEND_ERROR;
        errorMessage = AddonError.errorMessages[errorCode];
        isFatal = false;
        break;
      default:
        break;
    }

    // MHP-2086
    if (data.type === Hls.ErrorTypes.NETWORK_ERROR && isFatal === false) {
      _nonFatalErrorsCount++;
      if (_nonFatalErrorsCount > _hls.config.fragLoadingMaxRetry) {
        _nonFatalErrorsCount = 0;
        isFatal = true;
      }
    }

    if (errorType && errorCode && errorMessage) {
      new AddonError(self.player, errorType, errorCode, errorMessage, isFatal, data.response ? data.response.code : null);
    }

    if (data && data.fatal) {
      setState(5); // Wait
      switch (data.type) {
        case Hls.ErrorTypes.MEDIA_ERROR:
          handleMediaError();
          break;
        case Hls.ErrorTypes.NETWORK_ERROR:
          self.log(",network error ...");
          self.emit("mediaError", { this: this, message: 'Network connect error' });
          break;
        default:
          self.log(", unrecoverable error");
          // self.dispose(); // TODO need fix
          self.emit("mediaError", { this: this, message: 'Fatal, unrecoverable error' });
          break;
      }
    }
  };

  var onLevelSwitch = function (event, data) {
    if (_hls.manualLevel === -1) {
      self.emit('autoQualitySwitch', data.level);
    }
  };

  var onVideoError = function (evt) {
    setState(5); // Wait
    if (evt.type === 'error') {
      var errorType, errorCode, errorMessage, isFatal;
      var errorTxt, mediaError = evt.currentTarget.error;
      switch (mediaError.code) {
        case mediaError.MEDIA_ERR_ABORTED:
          errorTxt = "You aborted the video playback";
          break;
        case mediaError.MEDIA_ERR_DECODE:
          errorTxt = "The video playback was aborted due to a corruption problem or because the video used features your browser did not support";
          handleMediaError();
          errorType = AddonError.errorTypes.PLAYBACK_ERROR;
          errorCode = AddonError.errorCodes[errorType].DECODING_ERROR;
          errorMessage = AddonError.errorMessages[errorCode];
          isFatal = false;
          return;
        case mediaError.MEDIA_ERR_NETWORK:
          errorTxt = "A network error caused the video download to fail part-way";
          break;
        case mediaError.MEDIA_ERR_SRC_NOT_SUPPORTED:
          handleMediaError(); //MHP-1613
          errorTxt = "The video could not be loaded, either because the server or network failed or because the format is not supported";
          break;
      }

      self.log(errorTxt);
      if (errorType && errorCode && errorMessage) {
        new AddonError(self.player, errorType, errorCode, errorMessage, isFatal);
      }
      self.emit("mediaError", { this: this, message: errorTxt });
    }
  };

  var handleMediaError = function () {
    if (self.config && self.config.autoRecoverError === true) {
      var level = _hls.currentLevel;

      var now = parseInt(new Date().getTime() / 1000);
      if (!_recoverDecodingErrorDate || (now - _recoverDecodingErrorDate) > 3000) {
        _recoverDecodingErrorDate = now;
        self.log(",try to recover media Error ...");
        _hls.recoverMediaError();

        if (self.get('position') < 1) {
          _hls.currentLevel = level;
        }

      } else {
        if (!_recoverSwapAudioCodecDate || (now - _recoverSwapAudioCodecDate) > 3000) {
          _recoverSwapAudioCodecDate = now;
          self.log(",try to swap Audio Codec and recover media Error ...");
          _hls.swapAudioCodec();
          _hls.recoverMediaError();
        } else {
          self.emit("mediaError", {
            this: this,
            message: " cannot recover, last media error recovery failed ..."
          });
        }
      }
    }
  };

  var onVideoLoadStart = function () {
    setState(3);
  };

  var onVideoCanPlay = function () {
    if (!_video) return;
    if (!_started) {
      self.emit("mediaCanPlay");
      if (self.player && !self.player.get('ad:showing')) {
        _video.play();
      }

      if (_startPosition > 0 && _video.duration > 0) {
        _startPosition = Math.min(_startPosition, _video.duration - 15);
      }
    }
    if (_startPosition > 0) {
      if (_video.currentTime >= _startPosition) {
        _startPosition = 0;
      } else {
        self.seekTo(_startPosition);
      }
    }

    hlsConfig.startPosition = -1;

    if (_isBuffering) {
      _isBuffering = false;
      self.emit('buffering', { isBuffering: false, timestamp: new Date().getTime(), isSeeking: _video.seeking });
      // console.log('IS BUFFERING FALSE; SEEKING',_video.seeking);
    }
  };

  var onVideoPause = function (pEvent) {
    if (_paused) {
      setState(2);
    } else if (_video.paused) {
      setState(5);
    }
  };

  var onVideoPlaying = function () {
    if (!_started) {
      var autoPlay = true;
      var vendorOptions = self.player.get('vendorOptions');
      if (vendorOptions && vendorOptions.autoplay !== undefined && vendorOptions.autoplay !== null) {
        autoPlay = vendorOptions.autoplay;
      }

      if (_startPosition > 0) {
        self.seekTo(_startPosition);
        if (vendorOptions && 'startSeconds' in vendorOptions) {
          delete vendorOptions.startSeconds; // MHP-2125 + MHP-2145
        }
      }

      // _bufferingIntervalId = setInterval(onBufferingInterval, INTERVAL_DELAY);
      // _lastTimestamp = new Date().getTime();

      if (autoPlay === false) {
        setState(2);
        _video.pause();
        _paused = true;
        _started = true;
        return;
      }
    }
    var dismissSeekToLiveAfterPause = self.player.get('vendor:dismissSeekToLiveAfterPause');
    if (_isLive && _paused && dismissSeekToLiveAfterPause !== true) {
      var newTime = Math.min(_video.duration - 3, Number.MAX_SAFE_INTEGER); // this 'min' is used in case if duration === Infinity
      if (newTime < 0) {
        newTime = 0;
      }
      _video.currentTime = newTime;
    }
    _started = true;
    _paused = false;
    _nonFatalErrorsCount = 0;
    setState(1);
  };

  var onVideoSeeked = function () {
    if (_video.currentTime >= 0.49) {
      self.emit("mediaSeekEnd");
      if (_stateBeforeSeeking) {
        setState(_stateBeforeSeeking);
        _stateBeforeSeeking = null;
      }
      if (_isSafari && !_video.paused) {
        onVideoPlaying();
      }
    }
  };

  var onVideoSeeking = function () {
    if (_video.currentTime >= 0.49) {
      self.emit("mediaSeekStart");
      setState(4);
    }
  };

  var onVideoVolumeChange = function () {
    if (self.player.get('muted') !== event.currentTarget.muted) {
      self[event.currentTarget.muted ? 'mute' : 'unMute']();
    } else {
      self.set('volume', _video.volume * 100);
    }
  };

  var onVideoDurationChange = function () {
    self.set('duration', _video.duration);
  };

  function onVideoWaiting(event) {
    var bufferTime = getBufferTime();
    if (!_paused && bufferTime <= 1) {
      _isBuffering = true;
      self.emit('buffering', { isBuffering: true, timestamp: new Date().getTime(), isSeeking: _video.seeking });
      setState(3);
    }
  }

  var onTimeUpdate = function () {
    if (_video.currentTime !== self.get('position')) {
      self.set('position', _video.currentTime);

      /*var state = self.get('state');

      if ((state === 5 || state === 3) &&
               !_video.paused &&
               !_video.ended &&
               !_video.seeking &&
               _video.currentTime > 1 &&
               !_paused
      ) {
        setState(1);
      }*/
    }

    if (
      self.get('duration') > 0 &&
      self.get('duration') - self.get('position') < 1 &&
      !_beforeCompleteFired &&
      !_isLive
    ) {
      _beforeCompleteFired = true;
      self.emit("mediaBeforeComplete");
    }

    for (var i = 0; i < _video.buffered.length; i++) {
      if (_video.buffered.start(i) <= self.get('position') && _video.buffered.end(i) > self.get('position')) {
        self.set('loadedFraction', _video.buffered.end(i) / self.get('duration'));
        break;
      }
    }

    if (Math.abs(_video.duration - _video.currentTime) <= 0.1 && !_isLive) {
      onVideoEnded();
    }
  };


  // function onBufferingInterval() {
  //   var timestamp = new Date().getTime();
  //   var elapsedTime = (timestamp - _lastTimestamp) / 1000;
  //
  //    if (!_bufferingDetected && _video.currentTime + DELTA_BUFFERING < (_lastPlayPos + elapsedTime) && !_paused && _started) {
  //     _bufferingDetected = true;
  //     self.emit('buffering', {isBuffering: true, timestamp: timestamp, isSeeking: _video.seeking});
  //     setState(3);
  //    }
  //
  //    if (_bufferingDetected && _video.currentTime + DELTA_BUFFERING >= (_lastPlayPos + elapsedTime) && !_paused) {
  //     _bufferingDetected = false;
  //     self.emit('buffering', {isBuffering: false, timestamp: timestamp, isSeeking: _video.seeking});
  //     setState(1);
  //    }
  //
  //    if (_lastPlayPos !== _video.currentTime || _paused) {
  //     _lastTimestamp = timestamp;
  //    }
  //
  //    _lastPlayPos = _video.currentTime;
  //
  // }

  var onVideoEnded = function () {
    toggleEvents(false);
    setState(0);
    _started = false;
  };

  var onManifestParsed = function (event, data) {
    if (_videoInfo['content_type'] === 'm_ch') return;
    var quality = self.player.get('quality');

    if (quality !== -1) {
      // If quality is not in the list of available qualities, set it to -1

      var fastCheck = data.levels.find(function (hlsLevel) { return isHlsLevelMatched(hlsLevel, quality); });
      if (!fastCheck) {
        quality = null;
      } else {
        var indexByName = getQualityIndexByName(quality);
        quality = indexByName != null && indexByName >= 0 ? indexByName : getBitrateIndex(quality);
      }
    }

    if (quality === null || quality === undefined) {
      quality = -1;
      self.player.set('quality', quality);
    }

    if (quality >= 0 && quality < _hls.levels.length) {
      _hls.currentLevel = quality;
    }

    if (quality === -1 && self.player.get('quality') !== quality) {
      _hls.currentLevel = quality;
      self.player.set('quality', quality);
    }

    self.emit('hls:manifestParsed', data);
  };

  function onFragLoaded(event, data) {
    self.emit('hls:chunkLoaded', data);
  }

  function onLevelLoaded(type, data) {
    if (data && data.details) {
      _isLive = data.details.live;
    }
  }

  function onAudioTrackUpdated(tape, data) {
    if (data.audioTracks.length === 1 && self.get('audioTrackList') && self.get('audioTrackList').length > 1 ) return; //MHP-647
    self.setAudioTrack = data.audioTracks.length ? setAudio : self.setAudioTrack;
    var defaultOptions = self.player.config.checkDefaultOptions
      ? self.player.config.checkDefaultOptions(self.get('videoInfo'))
      : {};
    if (data.audioTracks.length && (defaultOptions.defaultAudioTrack || parseInt(defaultOptions.defaultAudioTrack) > 0 )) {
      if (_started) _video.pause();
      setAudio(parseInt(defaultOptions.defaultAudioTrack));
      _video.currentTime = _video.currentTime + 4;
      _video.play();
    }
  }

  function onAudioTrackSwitched(type, audio) {
    var currentAudio = _hls.audioTrackController.audioTracks[audio.id];
    var trackList = self.get('audioTrackList');
    for (var i = 0; i < trackList.length; i++) {
      var track = trackList[i];
      var streamTrackLang = track.lang_iso_639_1 || track.lang;
      track.is_active = streamTrackLang === currentAudio.lang;
      if (streamTrackLang === currentAudio.lang) {
        self.set('audioTrack', track.id);
      }
    }
  }

  function setAudio(pId) {
    if (_hls) {
      const streamTrack = self.get('audioTrackList').find((track) => track.id === pId);

      if (!streamTrack){
        // TODO: send warning to somewhere?
        return;
      }

      const lang = [
        streamTrack.lang_iso_639_1 /* preferred, correct lang code */,
        streamTrack.lang /* legacy in-correct lang code */,
      ];
      const byLangMatching = (track) => lang.includes(track.lang);
      const hlsTrack = _hls.audioTrackController.audioTracks.find(byLangMatching);

      if (!hlsTrack){
        // TODO: send warning to somewhere?
        return;
      }

      _hls.audioTrackController.audioTrack = hlsTrack.id;
      self.set('audioTrack', streamTrack.id);
    }
  }

  function getBufferTime() {
    var result = -1;
    var video = self.player.getPlayableElement();
    if (video && video.buffered && video.buffered.length > 0) {
      var i = video.buffered.length;
      var pos = self.player.get('position');
      while (i--) {
        if (video.buffered.start(i) <= pos && video.buffered.end(i) >= pos) {
          result = video.buffered.end(i) - pos;
        }
      }
    }
    return result;
  }

  self.log('MggpVendorHls:Created!');
}


MggpVendorHls.prototype = Object.create(MggpVendor.prototype);
MggpVendorHls.prototype.constructor = MggpVendorHls;

MggpVendorHls.mimeTypes = [ "m3u8" ];
MggpVendorHls.priority = 0;

MggpVendorHls.canPlay = function (type, config, options) {
  var result = false;
  var isDrm = options && 'isDrm' in options ? options.isDrm : config.drm;
  if (!isDrm) {
    result = Hls.isSupported();
  }
  return result;
};

module.exports = MggpVendorHls;
